import React from 'react';

import Title from './Title';
import Body from './Body';
import Container from './Container';
import OrderedList from './OrderedList';

export default () => (
  <Container>
    <Title>How it works</Title>
    <Body>
      <p>Congrats! You have successfully setup your item for delivery. Now what’s next?</p>
      <OrderedList>
        <li>You do your regular posting on your favorite marketplace, mentioning you’re offering delivery.</li>
        <li>
          Once you have found a buyer, give them your item link. They need to enter their shipping address, desired
          delivery and payment method.
        </li>
        <li>
          Your payment will be secured with us, you then ship the item to your buyer. When they received it, your
          payment arrives on your account on the next day.
        </li>
      </OrderedList>
    </Body>
  </Container>
);
